import { TasksProvider } from './../../providers/tasks/tasks';
import { TaskDetailPage } from './../task-detail/task-detail';
import { Component, ChangeDetectorRef } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
  AlertController,
  LoadingController
} from 'ionic-angular';
import { TaskQL, Task } from '../../providers/tasks/models';
import { ProvidersProvider } from '../../providers/providers/providers';
import { Provider } from '../../providers/providers/models';
import { UtilsProvider } from '../../providers/utils/utils';
import { LocationProvider } from '../../providers/location/location';
import { AuthProvider } from '../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-tasks',
  templateUrl: 'tasks.html'
})
export class TasksPage {
  public tasks;
  public providers: Provider[];
  private updateTask: any;
  private loader: any;
  public isLoading: boolean = true; 

  public futureScheduledTask: TaskQL[] = [];
  public currentWeekScheduledTask: TaskQL[] = [];
  public currenDayScheduledTask: TaskQL[] = [];

  public currentTasks: TaskQL[];
  public futureTasks: TaskQL[];

  public taskState: string = 'unscheduled';
  public remainingTime: {id: string, createdTime: number, remainingTime: string}[];
  public todayEnd: Date = new Date();
  public todayThreshold: Date = new Date();
  public mySNN: string = undefined;
  private hasAllowedLocation: boolean = false;
  public isScheduler: boolean = false;
  public canSearch: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private tasksProvider: TasksProvider,
    private providersProvider: ProvidersProvider,
    public utilsProvider: UtilsProvider,
    public loadingCtrl: LoadingController,
    private locationProvider: LocationProvider,
    private authProvider: AuthProvider,
  ) {
    this.updateTask = this.navParams.get('updateTask');
    this.navParams.data.updateTask = null;
  }

  ionViewDidLoad() {
    this.todayEnd.setHours(23);
    this.todayEnd.setMinutes(59);
    this.todayEnd.setSeconds(59);
    this.todayThreshold.setHours(0);
    this.todayThreshold.setMinutes(0);
    this.mySNN = this.authProvider.userData?.data.uid;
    this.isScheduler = this.authProvider.userData?.isSchedular;
    this.canSearch = true;
    this.cd.markForCheck();
  }

  ionViewDidEnter() {
    this.utilsProvider.userSyncCheck();
    this.providersProvider.getCompaniesQL().subscribe(companies => {
      this.providersProvider.getProviders().subscribe(providersResult => {
        this.providers = providersResult;
        this.locationProvider.getLocation().subscribe(position => {
          this.hasAllowedLocation = position?.coords?.latitude;
          this.initTasks();
        })
      });
    })
  }

  initTasks(event?, searchTerm?) {
    if (!searchTerm) {
      this.resetSearch();
    }
    this.presentLoading();
    this._initTasksEndpoint(event, searchTerm); //<-- Use this for endpoint
  }

  _initTasksGQL(event, searchTerm) {
    let parseFilters:any = { status : { _in: this.taskState === "scheduled" ? [Task.StatusEnum.Scheduled, Task.StatusEnum.Inprogress] : [Task.StatusEnum.Unscheduled, Task.StatusEnum.ToReschedule]}};
    if (searchTerm) { parseFilters.name = { _in: `%${searchTerm}%` } }

    this.tasksProvider
      .getTasks({
        limit: 100,
        filters: parseFilters,
        sortFilter: { field: 'createdDate', direction: 'ASC' }
      }, false)
      .subscribe(data => {
        this._prepareTaskList(data.items)
        if (event) event.complete();
      });
  }

  _initTasksEndpoint(event, searchTerm) {
    let parseFilters:any = { 
      statuses: this.taskState === 'scheduled' ? ['scheduled', 'inprogress'] : ['unscheduled', 'to-reschedule'], 
      sort: 'createdDate',
      dir: 1, 
      limit: 2000
    };
    if (searchTerm) { 
      parseFilters.name = searchTerm; 
    };

    this.tasksProvider.postTaskListForUser(parseFilters).subscribe(data => { 
      this._prepareTaskList(data);
      if (event) event.complete();
    });
  }

  _prepareTaskList(data: any) { 
    const tasks = data;
    if (tasks.length > 0) {
      this.currentTasks = tasks.filter(thisTask => {
        const scheduled = thisTask.status === Task.StatusEnum.Scheduled || thisTask.status === Task.StatusEnum.Inprogress
        if(scheduled) {
          const dayMilli = 1000 * 60 * 60 * 24;
          const tomorrowThresh  = this.todayThreshold.getTime() + dayMilli;
          const nextWeekThresh  = this.todayThreshold.getTime() + (dayMilli * 7);

          if (thisTask.assignedDate <= tomorrowThresh) {
            this.currenDayScheduledTask.push(thisTask);
          } else if (thisTask.assignedDate <= nextWeekThresh){
            this.currentWeekScheduledTask.push(thisTask);
          } else {
            this.futureScheduledTask.push(thisTask);
          }
        }
        return scheduled;
      });

      this.futureTasks = tasks.filter(thisTask => {
        if(this.tasksProvider.isHiddenTasks(thisTask.id)) return false;
        if(this.utilsProvider.hideTaskFromUser(thisTask)) return false;
        return thisTask.status !== Task.StatusEnum.Scheduled && thisTask.status !== Task.StatusEnum.Inprogress;
      });

      if (this.futureTasks.length) {
        this.handleOpenNewTaskQuery();
        this.initFutureTaskCountdown();
      }

      if (this.updateTask) {
        const redirectTask = this.tasks.filter(thisTask => { return thisTask.id === this.updateTask.id })[0];
        if (redirectTask) { this.openTask(redirectTask); }
      }
    }
    this.cd.detectChanges();
    this.loader.dismiss();
    this.isLoading = false;
  }

  doRefresh(event) {
    this.initTasks(event);
  }

  tasksToggle(taskType){
    this.taskState = taskType;
    this.initTasks();
  }

  taskSearchToggle(searchTerm){
    this.initTasks(undefined, searchTerm);
  }

  openTask(task) {
    const cacheTask = JSON.parse(JSON.stringify(task));
    this.tasksProvider.setSelectedTask(cacheTask);
    this.navCtrl.push(TaskDetailPage, { task: cacheTask, fromSchedulePage: true });
  }

  presentLoading(content: string = '') {
    if(!this.hasAllowedLocation) return;
    this.isLoading = true;
    this.utilsProvider.checkVersion();
    this.currentTasks = [];
    this.futureTasks = [];
    this.currenDayScheduledTask = [];
    this.currentWeekScheduledTask = [];
    this.futureScheduledTask = [];
    const status = { _in: [Task.StatusEnum.Unscheduled, Task.StatusEnum.ToReschedule]};
    if(this.taskState === 'scheduled'){ status._in = [Task.StatusEnum.Scheduled, Task.StatusEnum.Inprogress]};

    this.loader = this.loadingCtrl.create({ content });
    this.loader.present();
  }

  initFutureTaskCountdown(){
    this.remainingTime = this.futureTasks.map(task => {
      return {
        id: task.id,
        createdTime: task.createdDate,
        remainingTime: this.getCountdownRemainder(task.schedulerMeta?.expiredTime)
      }
    })
  }

  getCountdownRemainder(acceptedDate: number){
    const remaining = acceptedDate - new Date().getTime();
    if(remaining < 0) return "00:00"
    return this.utilsProvider.millisToMinutesAndSeconds(remaining)
  }

  handleOpenNewTaskQuery(){
    const urlString = window.location.href;
    const url = new URL(urlString);
    const taskId = url.searchParams.get("task");
    if(!taskId) return;
    const taskToOpen = this.futureTasks?.find(task => task.id === taskId);
    if(taskToOpen) this.openTask(taskToOpen);
    //Remove query from url
    history.pushState({}, null, urlString.substring(0, urlString.indexOf('?')));
  }

  hasTasksToShow(){
    if (this.currentTasks && this.currentTasks.length > 0 || this.futureTasks && this.futureTasks.length > 0) {
      return true;
    }
    return false;
  }

  resetSearch() {
    this.canSearch = false;
    setTimeout(() => {
      this.canSearch = true;
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/tasks.ts